import React from 'react';
import PropTypes from 'prop-types';


/* Simple button has following props: 
    1) button text,  2) onClickHandler 3)  number of words (to guage size) 4) color 5) alternate style
    Note: alternate style is commented out. Just uncommment if you plan to use an alternative style
*/

export const SimpleButton  = (props) => {
    let buttonstyle = "simple-button"
    let numWords    = 0;

    /* construct class name */
    if (props.color) {
        buttonstyle = buttonstyle + '-' + props.color;
    }
    if (props.words) { 
        buttonstyle = buttonstyle + '-' + props.words;
    } 

    /* set type property */
    let type = props.type || "button"

    // if (props.altstyle) { 
    //     buttonstyle = "simple-button-alt";
    // } 

    /* If button is being used on a form, you don't need the onClickHandler. If the onclickHandler
       prop is not specified, button will be rendered without the onClick handler and without the button type. */
    return  (
    props.onClickHandler ? (
        <button onClick={props.onClickHandler} className={buttonstyle} type={type}>
             {props.buttonText}
         </button>
        ) : (
        <button className={buttonstyle}>
             {props.buttonText}
        </button>
        )
    )
}

SimpleButton.propTypes = {
    buttonText:     PropTypes.string.isRequired,
    onClickHandler: PropTypes.func,
    altstyle:       PropTypes.string,
    color:          PropTypes.string,
    words:          PropTypes.number,
    type:           PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/buttons/SimpleButton.js